import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GlobalUtilityService {
  isInternetUp: boolean = true;
  constructor(public router: Router) {}

  /**
   * Get last row index of table rows
   */
  getLastRowIndex(request, results, total) {
    if (!results || results.length === 0) {
      return request.startRow;
    }
    let currentLastRow: any;
    if (results.length < request.endRow - request.startRow) {
      currentLastRow = request.startRow + results.length;
    } else if (request.endRow == total) {
      currentLastRow = request.startRow + results.length;
    } else {
      currentLastRow = request.startRow + (results.length + 1);
    }
    return currentLastRow <= request.endRow ? currentLastRow : -1;
  }

  /**
   * Check given number is number or not
   */
  isNumeric = (num: any) =>
    (typeof num === 'number' || (typeof num === 'string' && num.trim() !== '')) &&
    !isNaN(num as number);

  /**
   * Compare two objects are equal
   */
  isDeepEqual = (object1, object2) => {
    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);

    if (objKeys1.length !== objKeys2.length) return false;

    for (let key of objKeys1) {
      const value1 = object1[key];
      const value2 = object2[key];

      const isObjects = this.isObject(value1) && this.isObject(value2);

      if ((isObjects && !this.isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
        return false;
      }
    }
    return true;
  };

  /**
   * Check given variables type is object
   */
  isObject = (object) => {
    return object != null && typeof object === 'object';
  };

  /**
   * Debounce function after given time
   * @param {any} func - Function that needs to be wait
   * @param {any} wait - Wait time in seconds
   */
  debounce = (func, wait, leading = false) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      if (leading && !timeout) {
        func.apply(this, args);
      }
      timeout = setTimeout(() => {
        timeout = null;
        if (!leading) {
          func.apply(this, args);
        }
      }, wait);
    };
  };
}
